<div class="page-container container-fluid p-3">
  <mat-tab-group (selectedIndexChange)="onTabChange($event)" [selectedIndex]="tabIndex">
    <mat-tab label="RFP History">
      <mat-card class="mt-2 p-0">
        <div>
          <div class="row m-0 mb-3 pt-3" *ngIf="!loading">
            <div class="col-sm-12  col-md-6 col-lg-3">
              <mat-select class="filterDropdown" placeholder="Select Filter Type" [formControl]="dropDownSelection" (selectionChange)="dropDownSelectionChange()">
                <ng-container *ngFor="let option of dropDownOptions">
                  <mat-option [value]="option.value" *ngIf="option.value != 'quoteId'">
                    {{option.label}}
                  </mat-option>
                </ng-container>
              </mat-select>
            </div>
            <div class="col-sm-12  col-md-6 col-lg-4" fxLayout="row">
              <input class="form-control" [disabled]="!dropDownSelection.value" mdbInput type="text" (ngModelChange)="search($event)" [(ngModel)]="searchValue" [placeholder]="getDropdownLabel()">
              <!--              <input *ngIf="dropDownSelection.value == 'facilityNumber'" class="form-control" [disabled]="!dropDownSelection.value" mdbInput type="text" [placeholder]="getDropdownLabel()" name="searchValue" [(ngModel)]="searchValue">-->
              <!--              <button mat-flat-button color="primary" class="search-btn ml-2" [disabled]="!dropDownSelection.value || !searchValue || searchValue.length < 5" *ngIf="dropDownSelection.value == 'facilityNumber'" (click)="searchFacilityNumber()">Search</button>-->
            </div>
          </div>
          <div style="background-color: whitesmoke">
            <div style="background-color: #54B4D3;color: white" class="p-2" fxLayout="row"
                 fxLayoutAlign="space-between center">
              <h2 class="m-0">RFP History </h2>
              <div>
<!--                <button mat-raised-button routerLink="/new-request">New RFP</button>-->
              </div>
            </div>
            <app-data-table class="data-table" #requestHistoryTable [stickyHeader]="true" [loading]="loading" [rows]="requestHistoryRows" [columnDefs]="displayedColumns" defaultSort="requestDatetime"></app-data-table>
          </div>
        </div>
      </mat-card>
    </mat-tab>
    <mat-tab label="Contract Generation History">
      <mat-card class="mt-2 p-0">
        <div>
          <div style="padding-top: 10vh" *ngIf="loading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
          <div class="row m-0 mb-3 pt-3" *ngIf="!loading">
            <div class="col-sm-12  col-md-6 col-lg-3">
              <mat-select class="filterDropdown" placeholder="Select Filter Type" [formControl]="dropDownSelection" (selectionChange)="dropDownSelectionChange()">
                <mat-option *ngFor="let option of dropDownOptions" [value]="option.value">
                  {{option.label}}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-sm-12  col-md-6 col-lg-4" fxLayout="row">
              <input class="form-control" [disabled]="!dropDownSelection.value" mdbInput type="text" (ngModelChange)="search($event)" [(ngModel)]="searchValue" [placeholder]="getDropdownLabel()">
<!--              <input *ngIf="dropDownSelection.value == 'facilityNumber'" class="form-control" [disabled]="!dropDownSelection.value" mdbInput type="text" [placeholder]="getDropdownLabel()" name="searchValue" [(ngModel)]="searchValue">-->
<!--              <button mat-flat-button color="primary" class="search-btn ml-2" [disabled]="!dropDownSelection.value || !searchValue || searchValue.length < 5" *ngIf="dropDownSelection.value == 'facilityNumber'" (click)="searchFacilityNumber()">Search</button>-->
            </div>
          </div>
          <div style="background-color: whitesmoke">
            <div style="background-color: #54B4D3;color: white" class="p-2" fxLayout="row"
                 fxLayoutAlign="space-between center">
              <h2 class="m-0">Contract Generation History </h2>
            </div>
            <app-data-table class="data-table" #contractHistoryTable [stickyHeader]="true" [loading]="loading" [rows]="requestHistoryRows" [columnDefs]="displayedColumns"></app-data-table>
          </div>
        </div>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>

